import React from "react";
import { AuthRoles } from "../../../configs/roles";
import { AccountUIProvider } from "./AccountUIContext";

//MENU
import { AccountUICard } from "./AccountUICard";
import { AccountProfileEdit } from "./pages/AccountProfileEdit";
import { AccountProfileResetPassword } from "./pages/AccountProfileResetPassword";

export const AccountRoutes = [
  {
    path: "/account",
    element: (
      <AccountUIProvider>
        <AccountUICard />
      </AccountUIProvider>
    ),
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/account/profile/:id/edit",
    element: (
      <AccountUIProvider>
        <AccountProfileEdit />
      </AccountUIProvider>
    ),
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/account/reset-password",
    element: (
      <AccountUIProvider>
        <AccountProfileResetPassword />
      </AccountUIProvider>
    ),
    auth: AuthRoles.ROLES_USER,
  },
];
